import { render, staticRenderFns } from "./userRemarkList.vue?vue&type=template&id=2d1643b0&scoped=true&"
import script from "./userRemarkList.vue?vue&type=script&lang=js&"
export * from "./userRemarkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1643b0",
  null
  
)

export default component.exports